import { Icon } from '@design-system';
import classNames from 'classnames';
import React from 'react';

interface Props {
  color?: 'default' | 'warning';
  disabled?: boolean;
  hint?: string;
  icon: 'edit' | 'chevron';
  onClick: () => void;
}

export const CardButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  color = 'default',
  disabled,
  hint,
  icon,
  onClick,
}) => {
  return (
    <>
      <button
        className={classNames(
          'flex w-full justify-between rounded-sm border border-divider/20 p-4 text-left transition duration-300 hover:text-neutral-4 md:p-4',
          {
            'cursor-not-allowed bg-neutral-1 text-neutral-4': disabled,
            'border-active-4': color === 'warning',
          },
        )}
        disabled={disabled}
        onClick={() => {
          if (!disabled) onClick();
        }}
        type="button"
      >
        <span className="w-full">{children}</span>
        {icon === 'chevron' && <Icon name="ic_chevron_right" />}
        {icon === 'edit' && <Icon name="ic_edit" />}
      </button>
      {hint && (
        <div
          className={classNames('mt-2 text-xs', {
            'text-neutral-4': disabled,
            'text-danger-4': color === 'warning',
          })}
        >
          {hint}
        </div>
      )}
    </>
  );
};
